import React from 'react';
import {Check} from 'lucide-react';
import './PriceCard.scss';
import Button from "../Button/Button";

interface SubscriptionCardProps {
    data: any,
    className?: string;
    onClick?: any;
    isCurrent?: boolean;
    hasSubscription?: boolean;
};

const formatPrice = (amount: number, currency: string) => {
    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency.toUpperCase(),
            minimumFractionDigits: 0,
            maximumFractionDigits: amount % 100 ? 2 : 0,
        }).format(amount / 100);
    } catch (e) {
        return `${amount / 100} ${currency.toUpperCase()}`;
    }
};

export default function SubscriptionCard({data, isCurrent, hasSubscription, className = '', onClick}: SubscriptionCardProps) {

    const limits = data?.limits;
    const features = limits ? [
        `${limits.maxChats} AI ${limits.maxChats === 1 ? 'chat' : 'chats'}`,
        `${limits.messagesPerMonth.toLocaleString()} messages / mo`,
        `${limits.voiceMessagesPerMonth.toLocaleString()} voice replies / mo`,
    ] : [];
    // Stripe products often repeat the name as the description
    const description = data?.description && data.description.trim().toLowerCase() !== data?.name?.trim().toLowerCase()
        ? data.description : null;

    return (
        <div
            className={`subscription-card ${isCurrent ? 'active-card' : ''} ${data?.highlighted ? 'subscription-card--highlighted' : ''} ${className}`}>
            {isCurrent ? <div className="subscription-card__badge">Current plan</div>
                : data?.highlighted && <div className="subscription-card__badge">Recommended</div>}

            <div className="subscription-card__header">
                <h3 className="subscription-card__name">{data?.name}</h3>
                {description && <p className="subscription-card__description">{description}</p>}
            </div>

            <div className="subscription-card__pricing">
                <span className="subscription-card__price">
                    {formatPrice(data?.amount || 0, data?.currency || 'usd')}
                </span>
                {data?.interval && <span className="subscription-card__interval">/ {data.interval}</span>}
            </div>

            <ul className="subscription-card__features">
                {features.map((feature) => (
                    <li key={feature} className="subscription-card__feature">
                        <span className="subscription-card__feature-icon"><Check size={14}/></span>
                        <span>{feature}</span>
                    </li>
                ))}
            </ul>

            {
                onClick || isCurrent ?
                    <Button disabled={isCurrent} type={'button'} onClick={onClick}
                            variant={isCurrent || !data?.highlighted ? 'secondary' : 'primary'}
                            title={isCurrent ? 'Current plan' : hasSubscription ? 'Switch plan' : 'Upgrade'}/>
                    : null
            }
        </div>
    );
}
